// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginatedTable_component_container__144dR","containerSelectable":"PaginatedTable_component_containerSelectable__35LPq"};